module.exports = __webpack_public_path__ + "c57017b6ab186db366eb5a38d185d8d2.svg";